import { Route, Switch } from 'react-router-dom';
import Separations from './cards/separations/Separations.component';
import EntranceExit from './cards/controlEntranceExit/EntranceExit.component';
import ParticularityStore from './cards/particularityStore/ParticularityStore.component';
import RegisterVehicles from './cards/registerVehicles/RegisterVehicles.component';
import SchedulingDock from './cards/schedulingDock/SchedulingDock.component';
import VehicleList from './cards/vehicleQueue/VehicleQueue.component';
import Report from './cards/report/Report.component'
import DockMonitoring from './cards/dockMonitoring/DockMonitoring.component';
import VehiclesMonitoring from './cards/vehiclesMonitoring/VehiclesMonitoring.component';
import DeliveryForecast from './cards/deliveryForecast/DeliveryForecast.component';
import StandbyPanel from './cards/standbyPanel/StandbyPanel.component';
import SideBar from '../patioManagement/sideBar/SideBar.component';


const Routes = () => {

  return (
    <Switch>
      <Route exact path="/gestao-de-patio" component={SideBar} />
      <Route exact path="/gestao-de-patio/operacoes-transporte" component={Separations} />
      <Route exact path="/gestao-de-patio/controle-entrada-saida-de-veiculos" component={EntranceExit} />
      <Route exact path="/gestao-de-patio/particularidades-das-lojas" component={ParticularityStore} />
      <Route exact path="/gestao-de-patio/cadastro-vinculo-motoristas-veiculos" component={RegisterVehicles} />
      <Route exact path="/gestao-de-patio/agendamento-das-docas" component={SchedulingDock} />
      <Route exact path="/gestao-de-patio/fila-de-veiculos" component={VehicleList} />
      <Route exact path="/gestao-de-patio/relatorio" component={Report} />
      <Route exact path="/gestao-de-patio/monitoramento-de-docas" component={DockMonitoring} />
      <Route exact path="/gestao-de-patio/monitoramento-de-veiculos" component={VehiclesMonitoring} />
      <Route exact path="/gestao-de-patio/previsao-de-entrega" component={DeliveryForecast} />
      <Route exact path="/gestao-de-patio/monitor-de-espera" component={StandbyPanel} />
      <Route component={() => <>Página não encontrada</>} />
    </Switch>
  );

}

export default Routes;
